/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'

// Soft UI Dashboard PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import DataTable from 'components/Tables/DataTable'

// Data
import dataTableData from 'layouts/applications/data-tables/data/dataTableData'
import investmentReferencesData from 'layouts/applications/data-tables/data/investmentReferencesData'
import financialDisclosuresData from 'layouts/applications/data-tables/data/financialDisclosuresData'

function DataTables() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox p={{ xs: 1, lg: 3 }}>
        <SoftBox>
          <Grid container justifyContent="center">
            <Grid item xs={12} xxl={10}>
              <Card
                sx={{
                  textAlign: 'left',
                  boxShadow: 0,
                  borderRadius: 2,
                  border: '1px solid #D2D6DA',
                }}
              >
                <DataTable
                  table={investmentReferencesData}
                  canSearch
                  entriesPerPage={{ defaultValue: 10 }}
                  alternateTableHeader="PARCO Webinars"
                  alternateTableSubHeader="Check out our Webinars below to get more detailed on explanations on your federal benefits and finances."
                />
              </Card>
            </Grid>
          </Grid>
        </SoftBox>
        {/* <Card>
          <SoftBox pt={3} lineHeight={1}>
            <SoftTypography variant="h5" fontWeight="medium">
              Financial Disclosures
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              Personal Investment Profile and Account Summary Reports
            </SoftTypography>
          </SoftBox>
          <DataTable table={financialDisclosuresData} canSearch />
        </Card> */}
      </SoftBox>
      {/* <Footer /> */}
    </DashboardLayout>
  )
}

export default DataTables
